import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { AspectRatioToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, LottieSizeTokens, LottieTokens, SizeTypeTokens, StackAlignItems, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { isMobile, isPartnerAffiliated, showCollateralTab, showEarning, showInviteAndEarnTab, showMFC } from '../../configs/utils';
import { ACTION } from './types';
import { closeMenu, navigate, onLogout } from './actions';
import AsyncStorage from "@react-native-async-storage/async-storage";
import { StoreKey } from "../../configs/api";
import { showAboutUs, showAccountDetails, showCGS, showCompletedApplications, showDashboard, showDemoVideos, showFaq, showLogout, showPendingApplications } from "../../configs/uri-config-utils";
import { getReferredPartnerSideNavTitle } from "../partnerWeb_Dashboard/utils";
import { initializeFirebase } from "../../configs/config";
const _isMobile = isMobile();
export const template = async (isFromPlatform, partnerAccountType, _user, routeId, referredPartnerTitle) => ({
    layout: {
        id: ROUTE.PARTNER_MENU,
        type: LAYOUTS.LIST,
        style: _isMobile ? {
            isPartnerPlatform: true,
            // height: heightMap[ROUTE.PARTNER_MENU]
        } : {
            //@ts-ignore
            isPartnerPlatform: true,
            // alignment: ModalAlignmentEnum.CENTER,
        },
        widgets: [
            { id: 'partnerMobHeaderContainer', type: WIDGET.STACK, position: POSITION.ABSOLUTE_TOP },
            { id: 'partnerMobBodyContainer', type: WIDGET.STACK },
            showLogout(_user) ? { id: 'partnerMobFooterContainer', type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM } : {}
        ],
    },
    datastore: {
        partnerMobHeaderContainer: {
            type: StackType.column,
            setStackClickable: true,
            width: StackWidth.MATCH_PARENT,
            padding: {
                top: SizeTypeTokens.XL,
            },
            widgetItems: [
                { id: 'PartnerCloseIconStack', type: WIDGET.STACK },
                { id: 'partnerMobHeaderSpace0', type: WIDGET.SPACE },
                { id: 'PartnerMobHeaderDivider', type: WIDGET.DIVIDER }
            ],
        },
        partnerMobFooterContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'partnerMobFooterDivider', type: WIDGET.DIVIDER },
                { id: 'partnerMobFooterContent', type: WIDGET.STACK }
            ]
        },
        partnerMobFooterContent: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.XXL,
                left: SizeTypeTokens.XXL
            },
            widgetItems: [
                { id: 'partnerMobFooterLogoutIcon', type: WIDGET.ICON },
                { id: 'partnerMobFooterSpace0', type: WIDGET.SPACE },
                { id: 'partnerMobFooterLogoutT1', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.LOGOUT,
                payload: {
                    isFromPlatform: isFromPlatform
                }
            }
        },
        partnerMobFooterLogoutT1: {
            label: 'Logout',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Primary_100
        },
        partnerMobFooterLogoutIcon: {
            name: IconTokens.Logout,
            color: ColorTokens.Primary_100,
            size: IconSizeTokens.SM
        },
        partnerMobFooterDivider: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Chalk
        },
        PartnerMobHeaderDivider: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Chalk
        },
        PartnerCloseIconStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            maxWidth: 200,
            setStackClickable: true,
            padding: {
                left: SizeTypeTokens.XL
            },
            widgetItems: [
                { id: 'PartnerCloseIcon', type: WIDGET.ICON }
            ],
            usePressable: true,
            action: {
                type: ACTION.CLOSE_MENU,
                routeId: ROUTE.PARTNER_MENU,
                payload: {
                    value: routeId
                }
            }
        },
        PartnerCloseIcon: {
            name: IconTokens.Cross,
            size: IconSizeTokens.XXXL
        },
        partnerMobHeaderSpace0: {
            size: SizeTypeTokens.XXL
        },
        partnerMobBodyContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'partnerMenuDivider0', type: WIDGET.DIVIDER },
                showDashboard(_user) ? { id: 'partnerDashboardContainer', type: WIDGET.STACK } : {},
                showDashboard(_user) ? { id: 'partnerMenuDivider0', type: WIDGET.DIVIDER } : {},
                showPendingApplications(_user) ? { id: 'partnerLeadsContainer', type: WIDGET.STACK } : {},
                showPendingApplications(_user) ? { id: 'partnerMenuDivider0', type: WIDGET.DIVIDER } : {},
                showCGS(_user) ? { id: 'partnerCapitalGainStatementContainer', type: WIDGET.STACK } : {},
                showCGS(_user) ? { id: 'partnerMenuDivider0', type: WIDGET.DIVIDER } : {},
                showCompletedApplications(_user) ? { id: 'partnerActiveCustomerContainer', type: WIDGET.STACK } : {},
                showCompletedApplications(_user) ? { id: 'partnerMenuDivider0', type: WIDGET.DIVIDER } : {},
                showMFC(partnerAccountType, _user) ? { id: 'partnerInterestCalculatorContainer', type: WIDGET.STACK } : {},
                showMFC(partnerAccountType, _user) ? { id: 'partnerMenuDivider0', type: WIDGET.DIVIDER } : {},
                showMFC(partnerAccountType, _user) ? { id: 'partnerCheckLimitContainer', type: WIDGET.STACK } : {},
                showMFC(partnerAccountType, _user) ? { id: 'partnerMenuDivider0', type: WIDGET.DIVIDER } : {},
                showEarning(partnerAccountType, _user) ? { id: 'partnerEarningContainer', type: WIDGET.STACK } : {},
                showEarning(partnerAccountType, _user) ? { id: 'partnerMenuDivider0', type: WIDGET.DIVIDER } : {},
                showInviteAndEarnTab(partnerAccountType, _user) ? { id: 'partnerReferredPartnerContainer', type: WIDGET.STACK } : {},
                showInviteAndEarnTab(partnerAccountType, _user) ? { id: 'partnerMenuDivider0', type: WIDGET.DIVIDER } : {},
                !_isMobile ? { id: 'partnerCustomerPortfolioContainer', type: WIDGET.STACK } : {},
                !_isMobile ? { id: 'partnerMenuDivider0', type: WIDGET.DIVIDER } : {},
                !isFromPlatform && showCollateralTab(partnerAccountType, _user) ? { id: 'partnerCollateralContainer', type: WIDGET.STACK } : {},
                !isFromPlatform && showCollateralTab(partnerAccountType, _user) ? { id: 'partnerMenuDivider0', type: WIDGET.DIVIDER } : {},
                !isFromPlatform && showDemoVideos(_user) ? { id: 'partnerDemoContainer', type: WIDGET.STACK } : {},
                !isFromPlatform && showDemoVideos(_user) ? { id: 'partnerMenuDivider0', type: WIDGET.DIVIDER } : {},
                !isFromPlatform && showAccountDetails(_user) ? { id: 'partnerProfileDetailContainer', type: WIDGET.STACK } : {},
                !isFromPlatform && showAccountDetails(_user) ? { id: 'partnerMenuDivider0', type: WIDGET.DIVIDER } : {},
                !isFromPlatform && showFaq(_user) ? { id: 'partnerFaqContainer', type: WIDGET.STACK } : {},
                !isFromPlatform && showFaq(_user) ? { id: 'partnerMenuDivider0', type: WIDGET.DIVIDER } : {},
                !isFromPlatform && showAboutUs(_user) ? { id: 'partnerAboutUsContainer', type: WIDGET.STACK } : {},
            ],
        },
        partnerInterestCalculatorContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            width: StackWidth.FULL,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                { id: 'partnerInterestCalculatorIcon', type: WIDGET.ICON },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'partnerInterestCalculatorT1', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.NAVIGATE,
                payload: {
                    route: ROUTE.INTEREST_CALCULATOR,
                }
            }
        },
        partnerInterestCalculatorIcon: {
            name: IconTokens.INTEREST_CALCULATOR,
            color: ColorTokens.Grey_Charcoal
        },
        partnerInterestCalculatorT1: {
            label: 'Interest calculator',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerCustomerPortfolioContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            width: StackWidth.FULL,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                { id: 'CheckLimitIcon', type: WIDGET.ICON },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'CustomerPortfolioT1', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.NAVIGATE,
                payload: {
                    route: ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO,
                    isFromPlatform: isFromPlatform
                }
            }
        },
        CustomerPortfolioT1: {
            label: 'View customer portfolio',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerCheckLimitContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            width: StackWidth.FULL,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                { id: 'CheckLimitIcon', type: WIDGET.ICON },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'CheckLimitT1', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.NAVIGATE,
                payload: {
                    route: isFromPlatform ? ROUTE.PARTNER_CHECK_LIMIT : ROUTE.PARTNER_CHECK_LIMIT,
                    isFromPlatform: isFromPlatform
                }
            }
        },
        CheckLimitIcon: {
            size: IconSizeTokens.XXL,
            name: IconTokens.Check_Limit_Grey,
            color: ColorTokens.Grey_Night
        },
        CheckLimitT1: {
            label: 'Eligibility check in 15s',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerReferredPartnerContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            width: StackWidth.FULL,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                isFromPlatform ? { id: "referredPartnerIcon", type: WIDGET.ICON } : { id: 'referredPartnerLottie', type: WIDGET.LOTTIE },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'ReferredPartnerT1', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.NAVIGATE,
                payload: {
                    route: isFromPlatform ? ROUTE.PLATFORM_LINKED_PARTNERS : ROUTE.PARTNER_REFERRED_PARTNER,
                    isFromPlatform: isFromPlatform
                }
            }
        },
        referredPartnerIcon: {
            name: IconTokens.LinkedPartners,
            color: ColorTokens.Grey_Night
        },
        referredPartnerLottie: {
            uri: LottieTokens.Gift,
            size: LottieSizeTokens.Size20,
            autoplay: true,
            aspectRatio: AspectRatioToken.A1_1
        },
        ReferredPartnerT1: {
            label: isFromPlatform ? 'Linked partners' : referredPartnerTitle ? referredPartnerTitle : 'Win a Trip to Bali',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerActiveCustomerContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            width: StackWidth.FULL,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                { id: 'ActiveCustomerIcon', type: WIDGET.ICON },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'ActiveCustomerT1', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.NAVIGATE,
                payload: {
                    route: isFromPlatform ? ROUTE.PLATFORM_ACTIVE_CUSTOMERS : ROUTE.PARTNER_ACTIVE_CUSTOMER,
                    isFromPlatform: isFromPlatform
                }
            }
        },
        ActiveCustomerIcon: {
            name: IconTokens.Leads,
            color: ColorTokens.Grey_Night
        },
        ActiveCustomerT1: {
            label: 'Completed applications',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerLeadsContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            width: StackWidth.FULL,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                { id: 'LeadIcon', type: WIDGET.ICON },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'LeadT1', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.NAVIGATE,
                payload: {
                    route: isFromPlatform ? ROUTE.PLATFORM_LEADS : ROUTE.PARTNER_LEAD,
                    isFromPlatform: isFromPlatform
                }
            }
        },
        LeadIcon: {
            name: IconTokens.Lead2,
            color: ColorTokens.Grey_Night
        },
        LeadT1: {
            label: 'Pending applications',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerDashboardContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            width: StackWidth.FULL,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                { id: 'DashboardIcon', type: WIDGET.ICON },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'DashboardT1', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.NAVIGATE,
                payload: {
                    route: ROUTE.PARTNER_DASHBOARD_V2,
                    isFromPlatform: isFromPlatform
                }
            }
        },
        DashboardIcon: {
            name: IconTokens.Grid_View,
            color: ColorTokens.Grey_Night
        },
        DashboardT1: {
            label: 'Dashboard',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerEarningContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            setStackClickable: true,
            width: StackWidth.FULL,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                { id: 'EarningIcon', type: WIDGET.ICON },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'EarningT1', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.NAVIGATE,
                payload: {
                    route: ROUTE.EARNING,
                }
            }
        },
        partnerCapitalGainStatementContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            setStackClickable: true,
            width: StackWidth.FULL,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                { id: 'partnerGainStatementIcon', type: WIDGET.ICON },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'partnerCapitalGainText', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.NAVIGATE,
                payload: {
                    route: ROUTE.PARTNER_CAPITAL_GAIN,
                }
            }
        },
        EarningIcon: {
            name: IconTokens.Earning,
            color: ColorTokens.Grey_Night
        },
        partnerGainStatementIcon: {
            name: IconTokens.CAPITAL_GAIN_STATEMENT,
            color: ColorTokens.Grey_Night
        },
        EarningT1: {
            label: 'Earnings',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerCapitalGainText: {
            label: 'Capital gain statement',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerCollateralContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            width: StackWidth.FULL,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                { id: 'CollateralIcon', type: WIDGET.ICON },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'CollateralT1', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.NAVIGATE,
                payload: {
                    route: ROUTE.COLLATERAL
                }
            }
        },
        CollateralIcon: {
            name: IconTokens.Collateral,
            color: ColorTokens.Grey_Night
        },
        CollateralT1: {
            label: 'Collaterals',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerDemoContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            width: StackWidth.FULL,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                { id: 'DemoIcon', type: WIDGET.ICON },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'DemoT1', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.NAVIGATE,
                payload: {
                    route: ROUTE.DEMO_VIDEOS
                }
            }
        },
        DemoIcon: {
            name: IconTokens.DemoVideo,
            color: ColorTokens.Grey_Night
        },
        DemoT1: {
            label: 'Demo videos',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerProfileDetailContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            width: StackWidth.FULL,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                { id: 'ProfileDetailIcon', type: WIDGET.ICON },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'ProfileT1', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.NAVIGATE,
                payload: {
                    route: ROUTE.MY_ACCOUNT
                }
            }
        },
        ProfileDetailIcon: {
            name: IconTokens.ProfileDetails,
            color: ColorTokens.Grey_Night
        },
        ProfileT1: {
            label: 'Account details',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerBillingDetailContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                { id: 'ProfileBillingIcon', type: WIDGET.ICON },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'ProfileBillingT1', type: WIDGET.TEXT }
            ]
        },
        ProfileBillingIcon: {
            name: IconTokens.BillingDetails,
            color: ColorTokens.Grey_Night
        },
        ProfileBillingT1: {
            label: 'Billing details',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerFaqContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            width: StackWidth.FULL,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                { id: 'partnerFaqIcon', type: WIDGET.ICON },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'partnerFaqT1', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.NAVIGATE,
                payload: {
                    route: isPartnerAffiliated(partnerAccountType) ? 'partner_Faq_Affiliated' : 'partner_Faq'
                }
            }
        },
        partnerFaqIcon: {
            name: IconTokens.Faq2,
            color: ColorTokens.Grey_Night
        },
        partnerFaqT1: {
            label: 'FAQs',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerAboutUsContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            width: StackWidth.FULL,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.SIZE18,
                left: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.SIZE18
            },
            widgetItems: [
                { id: 'partnerAboutUsIcon', type: WIDGET.ICON },
                { id: 'partnerMobMenuSpace0', type: WIDGET.SPACE },
                { id: 'partnerAboutUsT1', type: WIDGET.TEXT }
            ],
            usePressable: true,
            action: {
                routeId: ROUTE.PARTNER_MENU,
                type: ACTION.NAVIGATE,
                payload: {
                    route: 'partner_AboutUs'
                }
            }
        },
        partnerAboutUsIcon: {
            name: IconTokens.AboutUs2,
            color: ColorTokens.Grey_Night
        },
        partnerAboutUsT1: {
            label: 'About us',
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        partnerMenuDivider0: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Chalk
        },
        partnerMenuDivider1: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Chalk
        },
        partnerMobMenuSpace0: {
            size: SizeTypeTokens.XL
        },
        partnerMobFooterSpace0: {
            size: SizeTypeTokens.LG
        }
    },
});
export const PartnerMobSideNav = {
    onLoad: async ({ ...props }, { isFromPlatform, routeId }) => {
        await initializeFirebase();
        const _user = JSON.parse(await AsyncStorage.getItem(StoreKey.userContext));
        const partnerAccountType = _user?.linkedPartnerAccounts[0]?.partnerAccountType;
        const referredPartnerTitle = await getReferredPartnerSideNavTitle();
        return Promise.resolve(template(isFromPlatform, partnerAccountType, _user, routeId, referredPartnerTitle));
    },
    actions: {
        [ACTION.CLOSE_MENU]: closeMenu,
        [ACTION.LOGOUT]: onLogout,
        [ACTION.NAVIGATE]: navigate
    },
};
